"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchScreenPopupShowType = void 0;
/**
 * 显示类型
 */
var LaunchScreenPopupShowType;
(function (LaunchScreenPopupShowType) {
    LaunchScreenPopupShowType[LaunchScreenPopupShowType["FULL_SEARCH"] = 0] = "FULL_SEARCH";
    LaunchScreenPopupShowType[LaunchScreenPopupShowType["HOT_SPOT"] = 1] = "HOT_SPOT";
    LaunchScreenPopupShowType[LaunchScreenPopupShowType["REWARD_TASK"] = 2] = "REWARD_TASK";
})(LaunchScreenPopupShowType = exports.LaunchScreenPopupShowType || (exports.LaunchScreenPopupShowType = {}));
